import { useState, useEffect } from 'react'

export interface Product {
  id: string
  businessId: string
  name: string
  sellingPrice: number
  variableCost: number
  unit: string
  isActive: number
  notes?: string | null
  createdAt: string
  updatedAt: string
  // derived
  contributionMargin?: number
  grossMarginPct?: number
}

export function useProducts(businessId?: string) {
  const [products, setProducts] = useState<Product[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchProducts = async () => {
    if (!businessId) return
    setIsLoading(true)
    try {
      const res = await fetch(`/api/businesses/${businessId}/products`)
      const json = await res.json() as any
      if (json.success) setProducts(json.data)
      else setError(json.error?.message || 'Gagal memuat produk')
    } catch {
      setError('Gagal memuat produk')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => { fetchProducts() }, [businessId])

  const createProduct = async (data: Omit<Product, 'id' | 'businessId' | 'createdAt' | 'updatedAt' | 'contributionMargin' | 'grossMarginPct'>) => {
    const res = await fetch(`/api/businesses/${businessId}/products`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    const json = await res.json() as any
    if (json.success) await fetchProducts()
    return json
  }

  const updateProduct = async (productId: string, data: Partial<Product>) => {
    const res = await fetch(`/api/businesses/${businessId}/products/${productId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    const json = await res.json() as any
    if (json.success) await fetchProducts()
    return json
  }

  const deleteProduct = async (productId: string) => {
    const res = await fetch(`/api/businesses/${businessId}/products/${productId}`, { method: 'DELETE' })
    const json = await res.json() as any
    if (json.success) await fetchProducts()
    return json
  }

  return { products, isLoading, error, createProduct, updateProduct, deleteProduct, refetch: fetchProducts }
}
